import React, { useState, useEffect } from "react";
import Team from "../../components/about/Team";
import Partners from "../../components/partners/Partners";
import About_news from "../../components/blog/about_news";
import Story from "../../components/about/Story";
import Meta from "../../components/Meta";
import ReactDOM from "react-dom";
import DownloadAppBanner from "../../components/partners/DownloadAppBanner";
import Benefit from "../../components/dao/Benefits";
import ProSaleBanner from "../../components/ico-landing/ProSaleBanner.jsx";
import { footerMenuList, socialIcons } from "../../data/footer_data";
import Link from "next/link";
import Image from "next/image";

const About = () => {

  return (
    <>
      {/* <!-- Page title --> */}
    <div className="relative h-full">
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <Image
          src="/images/gradient.jpg"
          layout='fill'
          objectFit='cover'
          priority='true'
          alt="gradient"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block h-full">
        <Image
          src="/images/desert.webp"
        layout='fill'
        objectFit='cover'
        priority='true'
        alt="gradient dark"
        />
      </picture>
      <section className="relative w-full h-full pt-24 lg:pb-96">
        <div className="container">
          {/* <!-- Page Title --> */}
          <div className="mx-auto max-w-2xl py-16 text-center">
            <h1 className="font-display text-jacarta-700 mb-8 text-4xl font-medium dark:text-white">
              About VirtueSekai
            </h1>
            <p className="lg:dark:text-jacarta-300 text-lg leading-normal">
              VirtueSekai Is An Upcoming Turn Based Visual Novel MMORPG With Major Focus On Art, Economy And Game Systems
            </p>
          </div>
        </div>
      </section>
      {/* <!-- Intro / Statistics --> */}

      <section className="">
        <div className="container">
          {/* <!-- Video Lightbox --> */}
          <figure className="rounded-xl flex relative mt-16 w-full justify-center overflow-hidden rounded-3xl lg:-mt-96">
            <Image
              alt="character1"
              src="/images/products/character_1.png"
              width='600'
              height='600'
            />
          </figure>
          {/* <!-- Statistics --> */}
       <ProSaleBanner />
        <Story compFor="about" />
        </div>

      </section>
      </div>
      
      {/* <!-- end intro / statistics --> */}
      {/* <!-- Story --> */}
     
      {/* <!-- end story --> */}
      <section className="relative flex-wrap dark:bg-jacarta-700">
      <div className="container">
            <div className="lg:flex lg:justify-between">
              {/* <!-- Image --> */}
            <div className="rounded-2x1 lg:p-6 p-6 lg:mt-8 lg:mb-14 lg:w-[55%] lg:pr-16">
                <h2 className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                  Events
                </h2>
                <p className="mb-8 w-full lg:text-lg md:text-lg text-sm dark:text-white">Events for VirtueSekai happen for every major holiday that airdrop special NFT rewards, there will also be special in game events and random events happening throughout the year!</p>
                <p className="mb-8 w-full lg:text-lg md:text-lg text-sm dark:text-white">Make sure to keep an eye on announcements regarding events on our twitter and discord!</p>
                 <Link href="/events">
                  <a className="inline-block rounded-full bg-accent py-2.5 px-8 mb-8 text-center text-sm font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark">
                  Events
                  </a>
            </Link>
                  <div className="flex space-x-5">
                {socialIcons.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <Link href={href} key={id}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group cursor-pointer"
                      >
                        <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                          <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                        </svg>
                      </a>
                    </Link>
                  );
                })}
              </div>
              </div>
              <div className="lg:w-[45%] hidden lg:block lg:mb-14">
                <div className="relative mt-12 ml-24">
                  <Image
                  alt="events"
                    src="/images/events.webp"
                    width="400"
                    height="400"
                  />
                </div>
              </div>

              {/* <!-- Info --> */}
            </div>
          </div>
      </section>
       <section className="relative flex-wrap" id="gameBG">
      <div className="container bg-jacarta-700/25">
            <div className="lg:flex lg:justify-between">
              {/* <!-- Image --> */}
            <div className="lg:w-[45%] pt-32 hidden lg:block md:mb-14">
                <div className="relative mr-24">
                  <Image
                  alt="character2"
                    src="/images/products/character2.png"
                    width="400"
                    height="400"
                    className="mt-8 w-[80%]"
                  />
                </div>
              </div>
            <div className="rounded-2x1 p-6 lg:mt-12 lg:mb-14 lg:w-[55%] lg:pl-16">
                <h2 style={{color: 'white'}}  className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                  Game
                </h2>
                <p style={{color: 'white'}}  className="mb-8 w-full lg:text-lg md:text-lg text-sm">The VirtueSekai game is a turn based visual novel massive multiplayer online role playing game. Essentially you will traverse to different zones encountering NPCs, monsters, quests and players in 2D and sometimes 2.5D setting.</p>
                <p style={{color: 'white'}}  className="mb-8 w-full lg:text-lg md:text-lg text-sm">Current features confirmed for the VirtueSekai game include quests you can complete for rewards, a battle system to fight monsters, an item converter to change in game items to NFTs, guild system, in game chat, party system, leaderboards, character stats, class system, skill trees, in game shops for regular and premium currency, auction house, crafting and professions.</p>
                <Link href="/game">
                <a
              className="inline-block rounded-full bg-accent py-2.5 px-8 mb-8 text-center text-sm font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
            >
              Game
            </a>
            </Link>
                  <div className="flex space-x-5">
                {socialIcons.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <Link href={href} key={id}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group cursor-pointer"
                      >
                        <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                          <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                        </svg>
                      </a>
                    </Link>
                  );
                })}
              </div>
              </div>

              {/* <!-- Info --> */}
            </div>
          </div>
      </section>
       <section className="relative flex-wrap" id="vtBG">
      <div className="container">
            <div className="lg:flex lg:justify-between">
              {/* <!-- Image --> */}
            
            <div className="rounded-2x1 p-6 lg:mt-12 lg:mb-14 lg:w-[55%] lg:pl-16">
                <h2 style={{color: 'white'}}  className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                  virtuetown
                </h2>
                <p style={{color: 'white'}}  className="mb-8 w-full lg:text-lg md:text-lg text-sm">virtuetown is a fun collection drawn by the developer instead of the artist, used to support the development of VirtueSekai!</p>
                <p style={{color: 'white'}}  className="mb-8 w-full lg:text-lg md:text-lg text-sm">Enjoy various mechanics of virtuetown such as burning for different NFTs and Farming Power coming soon!</p>
                  <Link href="/virtuetown">
                  <a
              
              className="inline-block rounded-full bg-accent py-2.5 px-8 mb-8 text-center text-sm font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
            >
              virtuetown
            </a>
            </Link>
                  <div className="flex space-x-5">
                {socialIcons.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <Link href={href} key={id}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group cursor-pointer"
                      >
                        <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                          <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                        </svg>
                      </a>
                    </Link>
                  );
                })}
              </div>
              </div>
              <div className="lg:w-[45%] pt-8 hidden lg:block md:mb-14">
                <div className="relative ml-24">
                  <Image
                  alt="vt"
                    src="/images/products/vt.png"
                    width="400"
                    height="400"
                    className="mt-8 w-[80%]"
                  />
                </div>
              </div>
              {/* <!-- Info --> */}
            </div>
          </div>
      </section>
           <section className="relative flex-wrap dark:bg-jacarta-700">
      <div className="container">
            <div className="lg:flex lg:justify-between">
              {/* <!-- Image --> */}
            <div className="lg:w-[45%] hidden lg:block md:mb-14">
                <div className="relative mr-24 pt-6">
                  <Image
                  alt="wings"
                    src="/images/products/wings.png"
                    width="400"
                    height="400"
                    className="mt-8 w-[80%]"
                  />
                </div>
              </div>
            <div className="rounded-2x1 p-6 lg:mt-12 lg:mb-14 lg:w-[55%] lg:pl-16">
                <h2 className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                  Supporter Packs
                </h2>
                <p className="mb-8 w-full lg:text-lg md:text-lg text-sm dark:text-white">Supporter Packs help progress the development of VirtueSekai and get you cool rewards in return!</p>
                <p className="mb-8 w-full lg:text-lg md:text-lg text-sm dark:text-white">Guarantee your spot in our beta of the VirtueSekai game and get WL, airdrops and other rewards!</p>
                  <Link href="/tiers">
                  <a
              className="inline-block rounded-full bg-accent py-2.5 px-8 mb-8 text-center text-sm font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
            >
              Supporter Packs
            </a>
            </Link>
                  <div className="flex space-x-5">
                {socialIcons.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <Link href={href} key={id}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group cursor-pointer"
                      >
                        <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                          <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                        </svg>
                      </a>
                    </Link>
                  );
                })}
              </div>
              </div>

              {/* <!-- Info --> */}
            </div>
          </div>
      </section>
       <Benefit />
      <DownloadAppBanner />
      <Partners />
    </>
  );
};

export default About;